import * as React from 'react';
import {
  GridColumnMenuContainer,
  GridColumnMenuSortItem,
  GridColumnMenuFilterItem,
  GridColumnMenuHideItem,
  GridColumnMenuProps,
} from '@mui/x-data-grid';

const CustomColumnMenu: React.FC<GridColumnMenuProps> = (props) => {
  const { hideMenu, colDef, open } = props;

  return (
    <GridColumnMenuContainer hideMenu={hideMenu} open={open} colDef={colDef}>
      <GridColumnMenuSortItem onClick={hideMenu} colDef={colDef} />
      <GridColumnMenuFilterItem onClick={hideMenu} colDef={colDef} />
      <GridColumnMenuHideItem onClick={hideMenu} colDef={colDef} />
    </GridColumnMenuContainer>
  );
};

export default CustomColumnMenu;
